// UK overall ranking – Guardian University Guide 2025 & QS World University Rankings 2025. Sources: theguardian.com/education, topuniversities.com (2025).

const data = [
  {
    _id: "65c8f7920c83d10491afb1f7",
    name: "Oxford",
    country: "United Kingdom",
    city: "England",
    address: "Wellington Square, Oxford OX1 2JD, United Kingdom",
    Qsranking: 3,
    Guardianranking: 1,
    website: "https://www.ox.ac.uk/",
    coursesOffered: [],
    __v: 0,
  },
  {
    _id: "65c8f6f70c83d10491afb1f4",
    name: "St Andrews",
    country: "United Kingdom",
    city: "Scotland",
    address: "St Andrews KY16 9AJ, United Kingdom",
    Qsranking: 104,
    Guardianranking: 2,
    website: "https://www.st-andrews.ac.uk/study/",
    coursesOffered: [],
    __v: 0,
  },
  {
    _id: "65c8f7f10c83d10491afb1f9",
    name: "Cambridge",
    country: "United Kingdom",
    city: "England",
    address: "The Old Schools, Trinity Ln, Cambridge CB2 1TN, United Kingdom",
    Qsranking: 5,
    Guardianranking: 3,
    website: "https://www.cam.ac.uk/",
    coursesOffered: [],
    __v: 0,
  },
  {
    _id: "65c8f8690c83d10491afb1fb",
    name: "London School of Economics",
    country: "United Kingdom",
    city: "London",
    address: "Houghton St, London WC2A 2AE, United Kingdom",
    Qsranking: 50,
    Guardianranking: 4,
    website: "https://www.lse.ac.uk/",
    coursesOffered: [],
    __v: 0,
  },
  {
    _id: "65c8f8f60c83d10491afb1fd",
    name: "Imperial College",
    country: "United Kingdom",
    city: "London",
    address: "Imperial College London, Exhibition Road, London SW7 2AZ",
    Qsranking: 2,
    Guardianranking: 5,
    website: "https://www.imperial.ac.uk/",
    coursesOffered: [],
    __v: 0,
  },
  {
    _id: "65c8f9760c83d10491afb1ff",
    name: "Durham University",
    country: "United Kingdom",
    city: "England",
    address: "The Palatine Centre, University, Stockton Rd, Durham DH1 3LE, UK",
    Qsranking: 89,
    Guardianranking: 6,
    website: "https://www.durham.ac.uk/",
    coursesOffered: [],
    __v: 0,
  },
  {
    _id: "65c8fa0e0c83d10491afb201",
    name: "University of Bath",
    country: "United Kingdom",
    city: "England",
    address: "Claverton Down, Bath BA2 7AY, United Kingdom",
    Qsranking: 150,
    Guardianranking: 7,
    website: "https://www.bath.ac.uk/",
    coursesOffered: [],
    __v: 0,
  },
  {
    _id: "65c8fa7e0c83d10491afb203",
    name: "Warwick",
    country: "United Kingdom",
    city: "England",
    address: "University of Warwick, Coventry CV4 7AL, UK",
    Qsranking: 69,
    Guardianranking: 8,
    website: "https://warwick.ac.uk/",
    coursesOffered: [],
    __v: 0,
  },
  {
    _id: "65c8fada0c83d10491afb205",
    name: "UCL",
    country: "United Kingdom",
    city: "England",
    address: "Gower St, London WC1E 6BT, United Kingdom",
    Qsranking: 9,
    Guardianranking: 9,
    website: "https://www.ucl.ac.uk/",
    coursesOffered: [],
    __v: 0,
  },
  {
    _id: "65c8fb440c83d10491afb207",
    name: "Loughborough University",
    country: "United Kingdom",
    city: "England",
    address: "Epinal Way, Loughborough LE11 3TU, United Kingdom",
    Qsranking: 224,
    Guardianranking: 10,
    website: "https://www.lboro.ac.uk/",
    coursesOffered: [],
    __v: 0,
  },
  {
    _id: "65c8fb450c83d10491afb208",
    name: "Lancaster University",
    country: "United Kingdom",
    city: "England",
    address: "Bailrigg, Lancaster LA1 4YW, United Kingdom",
    Qsranking: 132,
    Guardianranking: 11,
    website: "https://www.lancaster.ac.uk/",
    coursesOffered: [],
    __v: 0,
  },
  {
    _id: "65c8fb460c83d10491afb209",
    name: "University of Edinburgh",
    country: "United Kingdom",
    city: "Scotland",
    address: "Old College, South Bridge, Edinburgh EH8 9YL, United Kingdom",
    Qsranking: 27,
    Guardianranking: 15,
    website: "https://www.ed.ac.uk/",
    coursesOffered: [],
    __v: 0,
  },
  {
    _id: "65c8fb470c83d10491afb20a",
    name: "University of Manchester",
    country: "United Kingdom",
    city: "England",
    address: "Oxford Rd, Manchester M13 9PL, United Kingdom",
    Qsranking: 34,
    Guardianranking: 16,
    website: "https://www.manchester.ac.uk/",
    coursesOffered: [],
    __v: 0,
  },
  {
    _id: "65c8fb480c83d10491afb20b",
    name: "University of Bristol",
    country: "United Kingdom",
    city: "England",
    address: "Beacon House, Queen's Rd, Bristol BS8 1QU, United Kingdom",
    Qsranking: 54,
    Guardianranking: 18,
    website: "https://www.bristol.ac.uk/",
    coursesOffered: [],
    __v: 0,
  },
  {
    _id: "65c8fb490c83d10491afb20c",
    name: "King's College London",
    country: "United Kingdom",
    city: "London",
    address: "Strand, London WC2R 2LS, United Kingdom",
    Qsranking: 40,
    Guardianranking: 28,
    website: "https://www.kcl.ac.uk/",
    coursesOffered: [],
    __v: 0,
  },
];

export default data;
